module.exports = "/_next/static/files/098dedb11d139f11a886879d70ee25b3.svg";